import type { Plan } from "./types";

const PLAN_CODE = /^[a-z][a-z0-9_]{0,63}$/;

function requestedCode(search: string): string | undefined {
  const values = new URLSearchParams(search).getAll("plan");
  return values.length === 1 && PLAN_CODE.test(values[0]) ? values[0] : undefined;
}

/** A URL carries intent only; availability and prices always come from the account API. */
export function requestedCheckoutPlan(search: string, plans: readonly Plan[]): Plan | undefined {
  const code = requestedCode(search);
  return plans.find((plan) => plan.code === code && plan.duration_days > 0 && plan.price_minor > 0 && plan.max_devices > 0);
}

export function checkoutAuthPath(mode: "login" | "register", search: string, selectedCode?: string): string {
  const params = new URLSearchParams();
  const code = selectedCode ?? requestedCode(search);
  if (code && PLAN_CODE.test(code)) params.set("plan", code);
  const referral = new URLSearchParams(search).get("ref");
  if (referral && /^[a-zA-Z0-9_-]{1,128}$/.test(referral)) params.set("ref", referral);
  return `/${mode}${params.size ? `?${params}` : ""}`;
}

export function afterAuthenticationPath(search: string, plans: readonly Plan[]): string {
  const plan = requestedCheckoutPlan(search, plans);
  return plan ? `/dashboard/subscription?plan=${encodeURIComponent(plan.code)}` : "/dashboard";
}
